export const userDashboardColors = {
  green: {
    text: '#2D6A4F',
    iconBg: '#D8F3DC',
  },
  blue: {
    text: '#0077B6',
    iconBg: '#CAF0F8',
    accent: '#0077B6',
  },
  purple: {
    text: '#5A189A',
    iconBg: '#E0AAFF',
  },
  neutral: {
    label: '#6B7280',
    heading: '#111827',
    sectionBg: '#F9FAFB',
    border: '#E5E7EB',
    pageBg: '#F3F4F6',
  },
} as const;

export type UserDashboardColorVariantType = 'green' | 'blue' | 'purple';
